import * as React from 'react';

const FootstepsSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="footsteps_svg__eds-icon--footsteps_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <g id="footsteps_svg__eds-icon--footsteps_right" fill="#010101">
            <path d="M19.6 2.1c-.2-.1-.4-.1-.6-.1-1.9 0-4 2.4-4.8 5.7-.6 2.2-.4 4.3.2 5.8l4.4 1.2c1.3-1 2.3-2.7 2.9-4.9.9-3.7 0-7.1-2.1-7.7zm1.1 7.5c-.4 1.7-1.2 3.1-2.2 4l-3.4-1c-.4-1.3-.4-3 0-4.7.8-3 2.6-4.9 3.9-4.9h.4c.6.2 1.2.9 1.5 2 .2 1.4.2 2.9-.2 4.6zM12.9 18.1c-.2.4-.3.9-.3 1.4.1 1.1.8 2.1 1.9 2.5h.7c.6 0 1.1-.2 1.6-.5.6-.5 1-1.3 1-2.1l.1-3.4-3.6-1-1.4 3.1zm4-1.4l-.1 2.5c0 .6-.2 1.1-.6 1.3-.3.2-.6.3-1 .3-.1 0-.3 0-.4-.1-.7-.2-1.2-.8-1.2-1.5 0-.2 0-.5.2-.8l1-2.4 2.1.7z" />
        </g>
        <g
            id="footsteps_svg__eds-icon--footsteps_left"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#010101"
        >
            <path d="M9.9 7.7C9 4.4 7 2 5 2c-.2 0-.4 0-.6.1-2.1.6-3 4-2.1 7.7.6 2.2 1.7 4 2.9 4.9l4.4-1.2c.7-1.5.8-3.6.3-5.8zm-1 4.9l-3.4 1c-1-.9-1.8-2.4-2.2-4.1-.4-1.6-.4-3.2-.1-4.4.3-1.1.8-1.8 1.5-2h.4C6.3 3 8.1 4.9 8.9 8c.4 1.7.4 3.3 0 4.6zM11 17.9l-1.5-3-3.6 1 .3 3.5c0 .5.2.9.4 1.3.5.8 1.3 1.3 2.2 1.3.2 0 .5 0 .7-.1.8-.2 1.4-.8 1.7-1.6.3-.7.2-1.6-.2-2.4zm-.7 2c-.2.5-.6.8-1.1 1-.1 0-.3.1-.4.1-.5 0-1-.3-1.3-.7-.1-.2-.2-.5-.2-.8L7 16.8l2-.6 1.1 2.2c.3.5.4 1.1.2 1.5z" />
        </g>
    </svg>
);

FootstepsSvg.displayName = 'FootstepsSvg';
export default FootstepsSvg;
